import { type GenericContentStoryblok } from '~/types/generated'
import { type GenericContentProps } from './GenericContent.interface'

export const mapGenericContent = (story: GenericContentStoryblok): GenericContentProps => {
  const title = story.title ?? null
  const introText = story.introText ?? undefined
  const bodyText = story.bodyText ?? undefined

  return {
    title,
    introText,
    bodyText
  }
}
